import { render, staticRenderFns } from "./LoadingModalDemo.vue?vue&type=template&id=40e3c320&scoped=true&"
import script from "./LoadingModalDemo.vue?vue&type=script&lang=js&"
export * from "./LoadingModalDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e3c320",
  null
  
)

export default component.exports